module.exports = __webpack_public_path__ + "img/banner4.46b83e29.png";